import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "smile",
  "use": "smile-usage",
  "viewBox": "0 0 20.774 7.024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.774 7.024\" id=\"smile\">\r\n  <path id=\"smile_路径_3388\" data-name=\"路径 3388\" class=\"cls-1\" d=\"M10.358,76.785A12.857,12.857,0,0,1,.3,72.049a1.338,1.338,0,0,1,.242-1.922,1.45,1.45,0,0,1,1.991.234,10,10,0,0,0,7.823,3.684A9.989,9.989,0,0,0,18.231,70.3a1.451,1.451,0,0,1,1.988-.252,1.338,1.338,0,0,1,.261,1.921,12.839,12.839,0,0,1-10.123,4.82Z\" transform=\"translate(0 -69.761)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol